import type { AxiosInstance } from 'axios';
import type {
  SearchRequest,
  SearchResponse,
} from '@/types';

export const searchDocs = async (
  api: AxiosInstance,
  text: string,
  num_docs: number,
  doc_types: string[] | undefined = undefined,
  doc_id: string | undefined = undefined,
): Promise<SearchResponse> => {
  const resp = await api.post<SearchResponse>('/search', {
    text,
    num_docs,
    doc_types,
    doc_id,
  } as SearchRequest);
  return resp.data;
};

